function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as constants from '../../../../../constants';
import messages from '../../../../../messages';
import styles from './ConfirmDeletePayerModal.pcss';
var _React_PureComponent;
class ConfirmDeletePayerModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.isInProgress && !this.props.isInProgress && !this.props.hasErrors) {
            this.props.onClose();
        }
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mb-5",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.deletePayer))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.cancel,
                            className: "btn col-6 mr-3",
                            onClick: ()=>this.props.onClose()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.delete,
                            className: "btn btn--filled btn--delete col-6 mr-3",
                            onClick: ()=>this.props.onDeletePayer()
                        })
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.DELETE_PAYER_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.deletePayer,
            styleModifier: "md",
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: this.renderContent()
        });
    }
}
_define_property(ConfirmDeletePayerModal, "propTypes", {
    onDeletePayer: PropTypes.func,
    // Explicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit props
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedConfirmDeletePayerModal = connect(mapStateToProps, mapDispatchToProps)(ConfirmDeletePayerModal);
export default withStyles(styles)(ConnectedConfirmDeletePayerModal);
